import { Routes } from '@angular/router';
import { queryGuard } from '@shared/guards/authorization/query.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'callback',
    loadComponent: () => import("@core/services/callback/callback.component").then((m) => m.CallbackComponent),
    canActivate: [queryGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('@pages/login-page/login-page.component').then(m => m.LoginComponent),
    title: 'Login solicitud de crédito',
    data: { configId: 'externos' }
  },
  {
    path: 'login-internos',
    loadComponent: () => import('@pages/login-page/login-page.component').then(m => m.LoginComponent),
    title: 'Login solicitud de crédito interno',
    data: { configId: 'internos' }
  },
  {
    path: 'solicitud-de-credito',
    loadComponent: () => import('@pages/credit-request-page/credit-request-page.component').then(m => m.CreditRequestPageComponent),
    title: 'Solicitud de Crédito',
  },
]